import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Building2, CalendarCheck, Send } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";

const API = process.env.REACT_APP_BACKEND_URL;

export default function RichiestaDemo() {
  const [form, setForm] = useState({
    nome_struttura: "",
    referente: "",
    email: "",
    telefono: "",
    tipologia: "RSA",
    numero_ospiti: "",
    comune: "",
    provincia: "",
    note: "",
    website: "",
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (key, value) => setForm((current) => ({ ...current, [key]: value }));

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const attribution = {};
    ["mkt_ref", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((key) => {
      const value = params.get(key);
      if (value) attribution[key] = value;
    });
    if (Object.keys(attribution).length) {
      sessionStorage.setItem("affidya_demo_attribution", JSON.stringify(attribution));
    }
  }, []);

  const attribution = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem("affidya_demo_attribution") || "{}");
      return saved && typeof saved === "object" ? saved : {};
    } catch {
      return {};
    }
  };

  const submit = async (event) => {
    event.preventDefault();
    if (!form.nome_struttura.trim() || !form.email.trim()) {
      toast.error("Inserisci il nome della struttura e l'email.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/api/public/richiesta-demo`, {
        ...form,
        numero_ospiti: form.numero_ospiti ? Number(form.numero_ospiti) : null,
        attribution: attribution(),
      });
      setSent(true);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Non è stato possibile inviare la richiesta. Riprova.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-50 px-4 py-10 md:py-16">
      <Card className="mx-auto max-w-2xl shadow-sm">
        <CardHeader className="text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100">
            <CalendarCheck className="h-6 w-6 text-indigo-700" />
          </div>
          <CardTitle className="text-2xl text-slate-900">Richiedi una demo di Affidya</CardTitle>
          <CardDescription>
            Raccontaci della tua struttura: un consulente ti contatterà per mostrarti la piattaforma.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-6 text-center">
              <Building2 className="mx-auto mb-3 h-8 w-8 text-emerald-600" />
              <h2 className="font-semibold text-emerald-900">Richiesta ricevuta</h2>
              <p className="mt-2 text-sm text-emerald-800">Ti contatteremo presto per concordare la demo.</p>
            </div>
          ) : (
            <form className="space-y-4" onSubmit={submit}>
              <input className="hidden" tabIndex="-1" autoComplete="off" value={form.website} onChange={(e) => set("website", e.target.value)} aria-hidden="true" />
              <div className="grid gap-4 md:grid-cols-2">
                <div className="md:col-span-2">
                  <Label>Nome della struttura *</Label>
                  <Input value={form.nome_struttura} onChange={(e) => set("nome_struttura", e.target.value)} required />
                </div>
                <div>
                  <Label>Referente</Label>
                  <Input value={form.referente} onChange={(e) => set("referente", e.target.value)} />
                </div>
                <div>
                  <Label>Email aziendale *</Label>
                  <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required />
                </div>
                <div>
                  <Label>Telefono</Label>
                  <Input value={form.telefono} onChange={(e) => set("telefono", e.target.value)} />
                </div>
                <div>
                  <Label>Tipologia</Label>
                  <Input value={form.tipologia} onChange={(e) => set("tipologia", e.target.value)} placeholder="RSA, casa di riposo..." />
                </div>
                <div>
                  <Label>Comune</Label>
                  <Input value={form.comune} onChange={(e) => set("comune", e.target.value)} />
                </div>
                <div>
                  <Label>Provincia</Label>
                  <Input value={form.provincia} onChange={(e) => set("provincia", e.target.value)} />
                </div>
                <div>
                  <Label>Numero indicativo ospiti</Label>
                  <Input type="number" min="0" value={form.numero_ospiti} onChange={(e) => set("numero_ospiti", e.target.value)} />
                </div>
              </div>
              <div>
                <Label>Come possiamo aiutarti?</Label>
                <Textarea value={form.note} onChange={(e) => set("note", e.target.value)} rows={4} />
              </div>
              <p className="text-xs text-slate-500">Inviando la richiesta autorizzi Affidya a ricontattarti per organizzare la demo.</p>
              <Button type="submit" className="w-full" disabled={sending}>
                <Send className="mr-2 h-4 w-4" />
                {sending ? "Invio in corso..." : "Richiedi la demo"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
